import React from 'react';
import { Box, Typography } from '@quillbot/design-system';

function QuillTab({
  active,
  children,
  onClick,
  ...otherProps
}: {
  active: boolean;
  children: string | JSX.Element | JSX.Element[];
  onClick: any;
}) {
  return (
    <Box
      px="16px"
      height="42px"
      display="flex"
      alignItems="center"
      bgcolor={active ? 'primary.main' : 'grey.50'}
      py="10px"
      sx={{ cursor: 'pointer', transition: 'all 0.4s' }}
      mx="8px"
      borderRadius="100px"
      border="1px solid rgba(76, 148, 89, 0.5)"
      onClick={onClick}
      {...otherProps}
    >
      <Typography
        fontSize="16px"
        color={active ? 'grey.50' : 'rgba(95, 99, 104, 1)'}
        fontWeight={600}
        whiteSpace="nowrap"
      >
        {children}
      </Typography>
    </Box>
  );
}

export default QuillTab;
